module.exports = __webpack_public_path__ + "static/1-bf526a83cecd67c5d784deb8d436fc5e.jpg";